"use client";

import styles from "./HeaderAuth.module.css";
import cn from "classnames";
import { Flex } from "antd";

import HeaderAuthProps from "./HeaderAuth.props";
import LocaleSwitcher from "../locale-switcher/LocaleSwitcher";
import {
  ReadonlyURLSearchParams,
  usePathname,
  useSearchParams,
} from "next/navigation";
import { AppNav } from "@/app/app-nav";
import { useEffect, useMemo, useState } from "react";
import Link from "next/link";
import Image from "next/image";
import ThemeSwitcher from "../ThemeSwitcher/ThemeSwitcher";
import { AppConstants } from "@/app/constants";
import { provideSession } from "@/app/utils";

export default function HeaderAuth({
  showThemeSwitcher,
  ...props
}: HeaderAuthProps) {
  const [session, setSession] = useState<string | null | undefined>(undefined);
  const pathName = usePathname();
  const searchParams = useSearchParams();
  const pathLink = useMemo(
    () => providePathLink(pathName, session),
    [pathName, session]
  );
  const authLink = useMemo(
    () => provideAuthLink(session, searchParams),
    [searchParams, session]
  );

  useEffect(() => {
    setSession(provideSession());
  }, []);

  return (
    <div {...props} className={cn(styles.wrp, props.className)}>
      <Flex vertical={false} className={styles.bar}>
        <Flex vertical={false} className={styles.leftGroup}>
          <span className={styles.title}>
            <Link className={styles.titleLink} href={pathLink}>
              <Image
                src="/icons/header/icon-menu-logo.svg"
                alt=""
                width={35}
                height={35}
                className={styles.titleLogo}
                unoptimized
              />
              <span className={styles.titleText}>{AppConstants.PoolName}</span>
            </Link>
          </span>
        </Flex>
        <Flex vertical={false} className={styles.rightGroup}>
          {showThemeSwitcher && (
            <>
              <ThemeSwitcher />
              <span className={styles.separator}>{"|"}</span>
            </>
          )}
          <LocaleSwitcher />
          {pathName && provideShowLogin(pathName) && (
            <div className={styles.authAction}>
              <span className={styles.separator}>{"|"}</span>
              <Link className={styles.authLink} href={authLink}>
                Login
              </Link>
            </div>
          )}
        </Flex>
      </Flex>
    </div>
  );
}

function providePathLink(
  path: string | undefined,
  session: string | null | undefined
): string {
  const purePath = path?.replaceAll("/", "");
  // const purePath = path != undefined ? replaceAllPolyfill(path,"/", "") : undefined;
  if (purePath == AppNav.Auth) return `${AppNav.Root}`;
  if (session) return `/${AppNav.Monitoring}`;
  if (purePath == "/") return `/${AppNav.Auth}`;
  return AppNav.Root;
}

function provideAuthLink(
  session: string | null | undefined,
  searchParams: ReadonlyURLSearchParams
) {
  if (session) return `/${AppNav.Monitoring}`;
  const nextParams = new URLSearchParams(searchParams.toString());
  nextParams.set("auth", "1");
  return `${AppNav.Root}?${nextParams.toString()}`;
}

function provideShowLogin(path: string): boolean {
  return path != `/${AppNav.Auth}` && path != `/${AppNav.Auth}/`;
}
